// The routing-segment badge of a ticket row (ticket.topic, set by the agent
// router). KI-321: a ticket without a topic says so — it used to read
// « Après-vente » by default, while the « Après vente » view (topic ==
// « Après vente ») did not list it.
export const topicBadge = (topic, t) => {
  const value = typeof topic === 'string' ? topic.trim() : '';
  if (!value) return { className: 'no-topic', label: t('noTopic', 'No topic') };
  if (value === 'Avant vente') return { className: 'presales', label: t('presales', 'Avant-vente') };
  if (value === 'chatbot') return { className: 'chatbot', label: t('chatbot', 'Chatbot') };
  if (value === 'Après vente') return { className: 'postsales', label: t('postsales', 'Après-vente') };
  // Any other segment of the account (or a router value such as SPAM): its own name.
  return { className: 'other-topic', label: value };
};

export default topicBadge;
